<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<div class="logo-container">
    <span [ngClass]="{'light-cyberark-logo': (theme$ | async) === 'light', 'dark-cyberark-logo': (theme$ | async) === 'dark'}" alt="CyberArk Logo"></span>
</div>
<div class="integration-wrapper" *ngIf="integrationId">
    <form [formGroup]="formGroup">
        <div>
            <mat-form-field class="field-input" appearance="outline">
                <mat-label>{{fAPIID}}</mat-label>
                <input matInput id="application_id" type="text"formControlName="application_id" placeholder="{{fAPIID}}">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="field-input" appearance="outline">
                <mat-label>{{fLogin}}</mat-label>
                <input matInput id="login_url" type="text"formControlName="login_url" placeholder="{{fLoginPHolder}}">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="field-input" appearance="outline">
                <mat-label>{{fUser}}</mat-label>
                <input matInput id="username" type="text" formControlName="username" placeholder="{{fUser}}">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="field-input" appearance="outline">
                <mat-label>{{fPass}}</mat-label>
                <input matInput id="password" type="password" formControlName="password" placeholder="{{fPassPholder}}}">
            </mat-form-field>
        </div>

        <div class="section">
            <mat-radio-group [formControl]="formGroup.controls.lock_option" aria-label="Select what happens when a threat is received.">
                <div>
                    <mat-radio-button value="device_only">{{fLockA}}</mat-radio-button>
                </div>
                <div>
                    <mat-radio-button value="device_sets">{{fLockB}}</mat-radio-button>
                </div>
                <div>
                    <mat-radio-button value="all_devices">{{fLockC}}</mat-radio-button>
                </div>
            </mat-radio-group>
        </div>

        <div class="section">
            <mat-checkbox [formControl]="formGroup.controls.admin_unlock" matTooltip="Coming Soon">{{fAdmin}}</mat-checkbox>
        </div>

        <button type="button" (click)="cancel()" mat-raised-button>{{fCancel}}</button>
        <button type="button" color="primary" (click)="save()" [disabled]="!formGroup.valid" mat-raised-button>{{fSave}}</button>
        <button type="button" color="accent" (click)="validate()" [disabled]="!formGroup.valid" mat-raised-button>{{fValidate}}</button>

    </form>
</div>
